import React from "react";
import { FiMaximize, FiArrowRight, FiArrowLeft } from "react-icons/fi";

export const ControlButtons = ({
  page,
  data,
  handleExpand,
  setPage,
  modal,
}) => {
  return (
    <div
      className="d-flex"
      style={{
        border: "none",
        width: modal ? "100%" : "660px",
        justifyContent: modal ? "center" : "space-between",
        position: "sticky",
        left: "0",
        bottom: "0",
        paddingTop: modal ? "0" : "1rem",
        bottom: "-19px",
        background: "white",
      }}
    >
      <div style={{ border: "none" }} className="pl-0 bg-white">
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          disabled={page === 0}
        >
          <FiArrowLeft className="" />
        </button>
        <span className="">
          {page + 1}/{data.length}
        </span>
        <button
          onClick={() => setPage((prev) => Math.min(prev + 1, data.length - 1))}
          disabled={page === data.length - 1}
        >
          <FiArrowRight className="" />
        </button>
      </div>
      {!modal && (
        <div style={{ border: "none" }} className="mr-2 pl-0 bg-white">
          <FiMaximize onClick={handleExpand} style={{ cursor: "pointer" }} />
        </div>
      )}
    </div>
  );
};
